// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


import Vue from 'vue'
import App from './App'
import VueFire from 'vuefire';
import { store } from './store/store.js';
import router from './router'
import VueScrollTo from 'vue-scrollto';
import VueAnalytics from 'vue-analytics'

Vue.use(VueScrollTo)

Vue.use(VueFire);
Vue.config.productionTip = false

const isProd = process.env.NODE_ENV === 'production';

Vue.use(VueAnalytics, {
  id: 'UA-24501714-5',
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
});

let app;
import Firebase from 'firebase'
Firebase.auth().onAuthStateChanged(function(user) {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      el: '#SecurityCheck',
      store,
      router,
      components: { App },
      template: '<App/>'
    })
  }
});



// WEBPACK FOOTER //
// ./src/main.js